import React, { lazy } from "react";
import { Suspense } from "react";
import { Audio } from "react-loader-spinner";

const DashBoard = lazy(() => import("../pages/DashBoard"));
const Login = lazy(() => import("../pages/Login"));
const ForgotPasswordForm = lazy(() =>
  import("../components/login/ForgotPasswordForm")
);
const SignInForm = lazy(() => import("../components/login/SignInForm"));
const ResetPasswordForm = lazy(() =>
  import("../components/login/ResetPasswordForm")
);
const Services = lazy(() => import("../pages/Services"));
const Statistics = lazy(() => import("../pages/Statistics"));
const Orders = lazy(() => import("../pages/Orders"));
const Settings = lazy(() => import("../pages/Settings"));
const NotFound = lazy(() => import("../pages/NotFound"));

const LoadingFallback = () => (
  <div className="flex items-center justify-center h-[50vh]">
    <Audio
      height="80"
      width="80"
      radius="9"
      color="#EE5222"
      ariaLabel="loading"
      wrapperStyle
      wrapperClass
    />
  </div>
);

export const routes = [
  {
    path: "/",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Login />
      </Suspense>
    ),
    meta: { auth: false },
    children: [
      {
        path: "",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <SignInForm />
          </Suspense>
        ),
      },
      {
        path: "forgot_password",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <ForgotPasswordForm />
          </Suspense>
        ),
      },
      {
        path: "reset_password",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <ResetPasswordForm />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/dashboard",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <DashBoard />
      </Suspense>
    ),
    meta: { auth: true },
  },
  {
    path: "/services",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Services />
      </Suspense>
    ),
    meta: { auth: true },
  },
  {
    path: "/statistics",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Statistics />
      </Suspense>
    ),
    meta: { auth: true },
  },
  {
    path: "/orders",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Orders />
      </Suspense>
    ),
    meta: { auth: true },
  },
  {
    path: "/settings",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Settings />
      </Suspense>
    ),
    meta: { auth: true },
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <NotFound />
      </Suspense>
    ),
    meta: { auth: false },
  },
];
